import { FilterType, filtersConfig } from '~/pages/AgreementsDashboard/agreementsDashboardFilters';
export const buildRelationshipsParamsFilter = (param)=>{
    let { type, isVendor, search, filters, clientContactId, customerId } = param;
    const filterParams = {};
    if (filters) {
        Object.entries(filtersConfig).forEach((param)=>{
            let [key, config] = param;
            const value = filters[key];
            if (!value) return;
            if (key === FilterType.AgreementStatus && value.length > 0) {
                filterParams['agreementStatusV2'] = value.join(',');
            } else {
                Object.assign(filterParams, config.getRequestParam(value));
            }
        });
    }
    const relationshipSummariesTypeFilterMap = {
        agreement: 'approved,terminated',
        agreementAndAdHoc: 'approved,terminated,adHoc',
        proposal: 'awaitingApproval,expired'
    };
    filterParams['status'] = relationshipSummariesTypeFilterMap[type];
    filterParams['search'] = search || undefined;
    filterParams['party'] = isVendor ? 'vendor' : 'customer';
    filterParams['clientContactId'] = clientContactId || undefined;
    filterParams['customerId'] = customerId || undefined;
    return filterParams;
};
